// removed by extract-text-webpack-plugin
module.exports = {"search":"search","search-control":"search-control","search-control-input":"search-control-input","button-clear-search":"button-clear-search"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/search/search.style.sass
// module id = sUV3
// module chunks = 0